<template>
	<v-container>
		<v-row>
			<v-col cols="12" sm="2" >
				<v-text-field label="Folio de Cita" v-model="datosCita.idCita" readonly></v-text-field>
			</v-col>
			<v-col cols="12" sm="5" >
				<v-text-field label="Paciente" v-model="datosCita.paciente" readonly></v-text-field>
			</v-col>
			<v-col cols="12" sm="5" >
				<v-text-field label="Terapeuta" v-model="datosCita.terapeuta" readonly></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="3">
				<v-text-field label="Fecha" v-model="datosCita.fecha" readonly></v-text-field>
			</v-col>
			<v-col cols="12" sm="3">
				<v-text-field label="Hora" v-model="datosCita.hora" readonly></v-text-field>
			</v-col>
			<v-col cols="12" sm="2">
				<v-switch v-model="acudio" label="¿Acudió?" color="teal teal-darken-4"></v-switch>
			</v-col>
			<v-col cols="12" sm="2">
				<v-switch v-model="ultimaSesion" label="¿Ultima?" color="teal teal-darken-4"></v-switch>
			</v-col>
			<v-col colse="12" sm="2">
				<v-text-field label="Num. Sesión" v-model="datosCita.numCita" readonly></v-text-field>
			</v-col>
		</v-row>
		<span v-if="!acudio">
			<v-row>
				<v-col cols="12" sm="12">
					<v-textarea
						label="Comentarios de Falta"
						v-model="comentariosDeFalta"
						:counter="3000"
						:rules="Datos3000TerapeutaRules"
						rows="3" background-color="teal lighten-5" color="teal teal-darken-4" prepend-icon="mdi-comment"
					></v-textarea>
				</v-col>
			</v-row>
		</span>
		<span v-if="acudio">
			<v-row>
				<v-col cols="12" sm="6">
					<v-menu
						ref="menu"
						v-model="menuHoraInicio"
						:close-on-content-click="false"
						:nudge-rigth="40"
						:return-value.sync="horaInicio"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="horaInicio"
								label="Hora de Inicio"
								prepend-icon="mdi-clock-time-four-outline"
								readonly
								v-bind="attrs"
								v-on="on"
							>
							</v-text-field>
						</template>
						<v-time-picker
							v-if="menuHoraInicio"
							v-model="horaInicio"
							full-widht
							@click:minute="$refs.menu.save(horaInicio)"
						></v-time-picker>
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6">
					<v-menu
						ref="menuFin"
						v-model="menuHoraFin"
						:close-on-content-click="false"
						:nudge-rigth="40"
						:return-value.sync="horaTermino"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="horaTermino"
								label="Hora de Término"
								prepend-icon="mdi-clock-time-four-outline"
								readonly
								v-bind="attrs"
								v-on="on"
							>
							</v-text-field>
						</template>
						<v-time-picker
							v-if="menuHoraFin"
							v-model="horaTermino"
							full-widht
							@click:minute="$refs.menuFin.save(horaTermino)"
						></v-time-picker>
					</v-menu>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6">
					<v-textarea 
						label="Objetivo Terapéutico"
						v-model="objetivoTerapeutico"
						:counter="18000"
						:rules="DatosTerapeutaRules"
						rows="5" background-color="teal lighten-5" color="teal teal-darken-4" 
						prepend-icon="mdi-comment"></v-textarea>
				</v-col>
				<v-col cols="12" sm="6">
					<v-textarea 
						label="Observacion del Paciente"
						v-model="observacionPaciente"
						:counter="18000"
						:rules="DatosTerapeutaRules"
						rows="5" background-color="teal lighten-5" color="teal teal-darken-4" 
						prepend-icon="mdi-comment"></v-textarea>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6">
					<v-textarea 
						label="Técnicas Terapéuticas"
						v-model="tecnicasTerapeuticas"
						:counter="18000"
						:rules="DatosTerapeutaRules"
						rows="5" background-color="teal lighten-5" color="teal teal-darken-4" 
						prepend-icon="mdi-comment"></v-textarea>
				</v-col>
				<v-col cols="12" sm="6">
					<v-textarea 
						label="Contenido"
						v-model="contenido"
						:counter="18000"
						:rules="DatosTerapeutaRules"
						rows="5" background-color="teal lighten-5" color="teal teal-darken-4" 
						prepend-icon="mdi-comment"></v-textarea>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6">
					<v-textarea 
						label="Tareas"
						v-model="tareas"
						:counter="18000"
						:rules="DatosTerapeutaRules"
						rows="5" background-color="teal lighten-5" color="teal teal-darken-4" 
						prepend-icon="mdi-comment"></v-textarea>
				</v-col>
				<v-col cols="12" sm="6">
					<v-textarea 
						label="Plan Terapéutico"
						v-model="planTerapeutico"
						:counter="18000"
						:rules="DatosTerapeutaRules"
						rows="5" background-color="teal lighten-5" color="teal teal-darken-4" 
						prepend-icon="mdi-comment"></v-textarea>
				</v-col>
			</v-row>
			<v-row :justify="'center'">
				<v-col cols="12" sm="6">
					<v-textarea 
						label="Bibliografía"
						v-model="bibliografia"
						:counter="3000"
						:rules="Datos3000TerapeutaRules"
						rows="5" background-color="teal lighten-5" color="teal teal-darken-4" 
						prepend-icon="mdi-comment"></v-textarea>
				</v-col>
			</v-row>
		</span>
		<span v-if="ultimaSesion">
			<v-row>
				<v-col>
					<v-combobox 
						label="Estatus Intervención" 
						v-model="statusIntervencion"
						:items="statusIntervencionLista"
						item-text="descripcion"
						item-value="id"
					>
					</v-combobox>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" sm="6">
					<v-textarea 
						label="Resultados Generales"
						v-model="resultadosGenerales"
						:counter="18000"
						:rules="DatosTerapeutaRules"
						rows="5" 
						background-color="teal lighten-5" 
						color="teal teal-darken-4" 
						prepend-icon="mdi-comment"
					></v-textarea>
				</v-col>
				<v-col cols="12" sm="6">
					<v-textarea 
						label="Conclusiones"
						v-model="conclusiones"
						:counter="18000"
						:rules="DatosTerapeutaRules"
						rows="5" 
						background-color="teal lighten-5" 
						color="teal teal-darken-4" 
						prepend-icon="mdi-comment"
					></v-textarea>
				</v-col>
			</v-row>
		</span>
		<v-row>
			<v-col cols="12" sm="4">
				<v-btn color="info" :disabled="!permiteGuardar" @click="enviaNotas">Guardar</v-btn>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="12" sm="6">
				<v-btn color="success" @click="cancelar">Cancelar</v-btn>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi.js'
export default {
	name: 'NotasDeSesion',
	data() {
		return {
			idCita: 0,
			permiteGuardar: true,
			acudio: false,
			ultimaSesion: false,
			comentariosDeFalta: '',
			numSesion: 0,
			menuHoraInicio: false,
			menuHoraFin: false,
			horaInicio: '',
			horaTermino: '',
			objetivoTerapeutico: '',
			observacionPaciente: '',
			tecnicasTerapeuticas: '',
			contenido: '',
			tareas: '',
			planTerapeutico: '',
			bibliografia: '',
			resultadosGenerales: '',
			conclusiones: '',
			respuesta: '',
			statusIntervencion: '',
			statusIntervencionLista: [],
			respuestaStatusIntervencion: '',
			respuestaNotas: '',
			infoNotasDeSesion: {},
			DatosTerapeutaRules: [
				value => value.length <= 18000 || "No debe exceder de 18000 caracteres."
			],	 
			Datos3000TerapeutaRules: [
				value => !!value || 'Dato requerido',
				value => value.length <= 3000 || "No debe exceder de 3000 caracteres."
			],
		}
	},
	
	props: {
		datosCita: {
			type: Object,
			required: true,
		},
		tipoInfo: {
			type: String,
			required: false,
		}
	},
	mounted: function() {
		ServiciosApi.statusPorTipo(3)
			.then(response => {
				this.respuestaStatusIntervencion = response.data
				console.log("respuesta", this.respuestaStatusIntervencion)
				this.statusIntervencionLista = this.respuestaStatusIntervencion.datos
				console.log("StatusIntervencion", this.statusIntervencionLista)
			})
			.catch(error => {
				console.log("Hubieron errores al montar buscando el estatus por tipo", error.response)
			})
		ServiciosApi.consultaNotas(this.datosCita.idCita)
			.then(response => {
				this.respuestaNotas = response.data
				console.log("Respuesta mounted", this.respuestaNotas)
				if(this.respuestaNotas.status === 'ok' && this.respuestaNotas.mensaje != 'Sin notas'){
					console.log("Datos" , this.respuestaNotas.datos.notas)
					this.muestraDatos(this.respuestaNotas.datos.notas)
				}
			})
			
	},
	methods: {
		enviaNotas() {
			let notasSesion =  {
				idCita: this.datosCita.idCita,
				acudio: this.acudio,
				ultimaSesion: this.ultimaSesion,
				comentariosDeFalta: this.comentariosDeFalta,
				numSesion: this.datosCita.numCita,
				horaInicio: this.horaInicio,
				horaTermino: this.horaTermino,
				objetivoTerapeutico: this.objetivoTerapeutico,
				observacionPaciente: this.observacionPaciente,
				tecnicasTerapeuticas: this.tecnicasTerapeuticas,
				contenido: this.contenido,
				tareas: this.tareas,
				planTerapeutico: this.planTerapeutico,
				bibliografia: this.bibliografia,
				resultadosGenerales: this.resultadosGenerales,
				conclusiones: this.conclusiones,
				statusIntervencion: this.statusIntervencion.id,
			}
			console.log("Notas:", notasSesion)
			ServiciosApi.agregaNotasDeSesion(notasSesion)
				.then(response => {
					this.respuesta = response.data
					console.log("Datos", this.respuesta)
				})
				.catch(error =>{
					console.log("Hubieron errores", error.response)
				})
			this.$emit("cancela-notas", this.idCita)
		},
		cancelar() {
			this.$emit("cancela-notas", this.idCita)
		},
		muestraDatos(notas){
			console.log("Entramos a muestra datos, con los datos" , notas)
			this.acudio = notas.acudio
			this.ultimaSesion = notas.ultimaSesion
			this.horaInicio = notas.horaInicio
			this.horaTermino = notas.horaFinalizacion
			this.objetivoTerapeutico = notas.objetivoTerapeutico
			this.observacionPaciente = notas.observacionPaciente
			this.tecnicasTerapeuticas = notas.tecnicasTerapeuticas
			this.contenido = notas.contenido
			this.tareas = notas.tareas
			this.planTerapeutico = notas.planTerapeutico
			this.bibliografia = notas.bibliografia
			this.resultadosGenerales = notas.resultadosGenerales
			this.conclusiones = notas.conclusiones
			this.permiteGuardar = false
			this.statusIntervencion = notas.statusIntervencion
		},
	},
}

</script>
